import { createRouter, createWebHistory } from "vue-router";
import SendMail from "../views/SendMail.vue";

const routes = [
  {
    path: "/mailform",
    name: "home",
    component: SendMail,
  },
  {
    path: "/about",
    name: "about",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/SendMail.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
